// LivestreamDetailModals.js
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import LivestreamDetailModals from '../component/LivestreamDetailModals.jsx';

import getOperationData from '../selector/getOperationData.js';

import removeModals from '../action/removeModals.js';
import addModal from '../action/addModal.js';
import addvalue from '../action/addvalue.js';
import setLiveStreamPanel from '../action/setLiveStreamPanel.js';

const mapStateToProps = state => {
  return {
    deviceWidth: getOperationData(state, ['device'], 'width'),
    deviceHeight: getOperationData(state, ['device'], 'height'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addvalue: () => dispatch(addvalue({ via: 'unlock-livestream' })),
    closeModal: ({ ids }) =>
      dispatch(
        removeModals({
          ids,
          transitionStatus: 'closing',
        })
      ),
    openModal: ({ id }) =>
      dispatch(
        addModal({ id, isHigherThanAll: true, transitionStatus: 'coming' })
      ),
    setGiftPanel: ({ isGiftPanelOpen }) =>
      dispatch(setLiveStreamPanel({ isGiftPanelOpen })),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LivestreamDetailModals)
);
